import script from "./IndexBloodingTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexBloodingTable.vue?vue&type=script&lang=ts&setup=true"

import "./IndexBloodingTable.vue?vue&type=style&index=0&id=f397e0d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f397e0d6"]])

export default __exports__